<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-form @submit.prevent="submit">
      <v-card>
        <v-card-title>
          {{ __("registrar tentativa de contacto manualmente") }}
          <v-spacer></v-spacer>
          <v-btn @click="close()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.date"
                :error-messages="validationErrors.date"
                type="date"
                :label="__('Data')"
                filled
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.time"
                :error-messages="validationErrors.time"
                type="time"
                :label="__('Hora')"
                filled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-alert dense type="warning" text outlined>
            {{ __("o registro manual não enviará SMS") }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="ml-2">
            <v-btn @click="close()" color="primary" text>{{
              __("Cancelar")
            }}</v-btn>
          </div>
          <div class="ml-2">
            <v-btn type="submit" color="primary">{{ __("registrar") }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import ToastsMixin from "@/mixins/ToastsMixin.vue";
import ValidationErrorsMixin from "@/mixins/ValidationErrorsMixin.vue";
import { failureToContactRetroactive } from "@/services/lead_schedules.js";
import i18n from "@/mixins/i18n";
export default {
  data() {
    return {
      i18n_prefix: "schedulings",
      dialog: false,
      schedules: [],
      form: {
        date: null,
        time: null,
      },
    };
  },
  mixins: [ToastsMixin, ValidationErrorsMixin, i18n],
  props: {
    scheduling: Object,
  },
  methods: {
    open() {
      this.dialog = true;
      this.resetForm();
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    reload() {
      this.$emit("reload");
    },
    resetForm() {
      this.form = {
        date: null,
        time: null,
      };
    },
    updateScheduling(scheduling) {
      this.schedules = this.schedules.map((item) => {
        if (item.id !== scheduling.id) {
          return item;
        }

        return { ...scheduling };
      });
    },

    async submit() {
      const data = {
        ...this.form,
        schedulingId: this.scheduling.id,
      };

      try {
        await this.handleFailureToContactRetroactive(data);
      } catch (error) {
        this.toastError(
          this.__("erro ao enviar formulário:", "schedulings"),
          error
        );
      }
    },

    async handleFailureToContactRetroactive(scheduling) {
      try {
        const response = await failureToContactRetroactive(
          scheduling.schedulingId,
          {
            date: scheduling.date,
            time: scheduling.time,
          }
        );

        this.updateScheduling(response.data);

        if (response.data.status === "letter") {
          this.toast(
            this.__("tentativa de contactar registada", "schedulings") +
              this.__("o limite de tentativas foi alcançado", "schedulings")
          );
        } else {
          this.toast(
            this.__("tentativa de contactar registada", "schedulings")
          );
        }
        this.$store.dispatch("refreshLead");
        this.close();
        this.reload();
      } catch (error) {
        if (error.response?.status === 400) {
          this.toastError(error.response?.data?.message);
          return;
        }

        this.toastError(
          this.__(
            "ocorreu uma falha ao registar a tentativa de contacto",
            "schedulings"
          )
        );
      }
    },
  },
};
</script>
